import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { LearningResourceType, Media, MediaType } from "src/interfaces/Media";

interface UseMediaListArgs {
  corporateId: string;
  mediaType?: MediaType;
  learningResourceType?: LearningResourceType;
  page: number;
  pageSize: number;
  search?: string;
}

export const useMediaList = ({
  corporateId,
  mediaType,
  learningResourceType,
  page,
  pageSize,
  search,
}: UseMediaListArgs): PaginatedListResult<Media> => {
  const buildUrl = () => {
    if (!corporateId) return null;
    const base = `${ServicesURL.library}?corporateId=${corporateId}&generateUrl=true`;
    if (learningResourceType) {
      return `${base}&learning_resource_type=${learningResourceType}`;
    }
    if (mediaType) {
      return `${base}&type=${mediaType}`;
    }
    return null;
  };

  return usePaginatedList<Media>(buildUrl(), { page, pageSize, search });
};
